/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable eqeqeq */
// ---------------------------------------------------------------------------------------------
// EPOD Admin Config screen - Configurations tab (epod_sla: one row per e-POD time window - value,
// unit, per-unit min/max, Skip Sundays, Skip holidays) + AL Approvals tab (al_team_directory
// Level 1/Level 2).
// Backend is authoritative: services/epodAdminConfigService.js re-checks authorization and every
// property on each update; this screen only mirrors those rules for inline feedback.
// Styling lives in the scoped <style> block below (eac-* classes) rather than the shared
// encss.css, same convention as epodScreen.js's .epod-tab-* rules.
// Departments: on a ?dept_code=LCV (or other) page the SLA calls carry dept_code and edit that
// dept's own values; a row not edited for the dept shows "Same as SPD". AL recipients are shared.
// ---------------------------------------------------------------------------------------------
import React, { Component } from 'react';
import SweetAlert from 'react-bootstrap-sweetalert';
var redirectURL = require('../redirectURL');
var { getDeptCode, withDeptCode } = require('../common/deptCode');

// The page's department, '' for SPD (no ?dept_code, or ?dept_code=SPD) = the default values.
const pageDept = () => { var d = getDeptCode(); return d === 'SPD' ? '' : d; };

const authHeaders = () => ({ headers: { 'Authorization': localStorage.getItem("userid") } });
const EMAIL_PATTERN = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
const MAX_EMAILS = 20;

// Rows are grouped by each field's own `group` (from the API), in the API's order.
const DEALER_WINDOW_KEYS = ['auto_clean', 'damage_window', 'shortage_window'];
const UNIT_WORDS = { days: ['day', 'days'], hours: ['hour', 'hours'], months: ['month', 'months'] };
const OWNER_CLASS = { 'LSP': 'eac-owner-lsp', 'Dealer': 'eac-owner-dealer', 'AL Team': 'eac-owner-al', 'System': 'eac-owner-system' };

const Icon = ({ name, size }) => {
    var s = size || 16;
    var common = { width: s, height: s, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2, strokeLinecap: 'round', strokeLinejoin: 'round', 'aria-hidden': true };
    switch (name) {
        case 'sliders': return <svg {...common}><line x1="4" y1="21" x2="4" y2="14" /><line x1="4" y1="10" x2="4" y2="3" /><line x1="12" y1="21" x2="12" y2="12" /><line x1="12" y1="8" x2="12" y2="3" /><line x1="20" y1="21" x2="20" y2="16" /><line x1="20" y1="12" x2="20" y2="3" /><line x1="1" y1="14" x2="7" y2="14" /><line x1="9" y1="8" x2="15" y2="8" /><line x1="17" y1="16" x2="23" y2="16" /></svg>;
        case 'users': return <svg {...common}><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M23 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" /></svg>;
        case 'refresh': return <svg {...common}><polyline points="23 4 23 10 17 10" /><polyline points="1 20 1 14 7 14" /><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" /></svg>;
        case 'undo': return <svg {...common}><polyline points="1 4 1 10 7 10" /><path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10" /></svg>;
        case 'save': return <svg {...common}><path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z" /><polyline points="17 21 17 13 7 13 7 21" /><polyline points="7 3 7 8 15 8" /></svg>;
        case 'x': return <svg {...common}><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>;
        case 'plus': return <svg {...common}><line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" /></svg>;
        case 'info': return <svg {...common}><circle cx="12" cy="12" r="10" /><line x1="12" y1="16" x2="12" y2="12" /><line x1="12" y1="8" x2="12.01" y2="8" /></svg>;
        case 'alert': return <svg {...common}><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" /><line x1="12" y1="9" x2="12" y2="13" /><line x1="12" y1="17" x2="12.01" y2="17" /></svg>;
        case 'lock': return <svg {...common}><rect x="3" y="11" width="18" height="11" rx="2" ry="2" /><path d="M7 11V7a5 5 0 0 1 10 0v4" /></svg>;
        default: return null;
    }
};

const STYLES = `
.eac-page{font-size:13px;color:#2d3748;}
.eac-header{display:flex;align-items:center;justify-content:space-between;flex-wrap:wrap;gap:12px;background:#fff;border:1px solid #e2e8f0;border-radius:8px;padding:16px 20px;margin-bottom:16px;}
.eac-title{margin:0;font-size:18px;font-weight:600;color:#1a202c;}
.eac-subtitle{margin:2px 0 0;color:#718096;font-size:12.5px;}
.eac-btn{display:inline-flex;align-items:center;gap:6px;border:1px solid transparent;border-radius:6px;padding:7px 14px;font-size:13px;font-weight:500;line-height:1.2;cursor:pointer;transition:background-color .15s,border-color .15s,color .15s,box-shadow .15s;white-space:nowrap;}
.eac-btn:focus{outline:none;box-shadow:0 0 0 3px rgba(49,130,206,.25);}
.eac-btn:disabled{opacity:.5;cursor:not-allowed;}
.eac-btn-sm{padding:5px 10px;font-size:12px;}
.eac-btn-primary{background:#2b6cb0;border-color:#2b6cb0;color:#fff;}
.eac-btn-primary:hover:not(:disabled){background:#2c5282;border-color:#2c5282;}
.eac-btn-outline{background:#fff;border-color:#cbd5e0;color:#4a5568;}
.eac-btn-outline:hover:not(:disabled){background:#f7fafc;border-color:#a0aec0;}
.eac-btn-ghost{background:transparent;color:#718096;padding:5px 8px;}
.eac-btn-ghost:hover:not(:disabled){background:#edf2f7;color:#2d3748;}
.eac-link{background:none;border:none;padding:0;color:#2b6cb0;font-size:11.5px;cursor:pointer;text-decoration:underline;}
.eac-link:disabled{color:#a0aec0;cursor:not-allowed;}
.eac-tabs{display:flex;gap:4px;border-bottom:2px solid #e2e8f0;margin-bottom:16px;}
.eac-tab{display:inline-flex;align-items:center;gap:8px;background:none;border:none;border-bottom:3px solid transparent;margin-bottom:-2px;padding:10px 18px;font-size:14px;font-weight:500;color:#718096;cursor:pointer;transition:color .15s,border-color .15s;}
.eac-tab:hover{color:#2d3748;}
.eac-tab:focus{outline:none;}
.eac-tab.active{color:#2b6cb0;border-bottom-color:#2b6cb0;}
.eac-tab-count{background:#edf2f7;color:#4a5568;border-radius:10px;padding:1px 8px;font-size:11.5px;font-weight:600;}
.eac-tab.active .eac-tab-count{background:#ebf8ff;color:#2b6cb0;}
.eac-dot{width:8px;height:8px;border-radius:50%;background:#dd6b20;display:inline-block;}
.eac-group{background:#fff;border:1px solid #e2e8f0;border-radius:8px;margin-bottom:14px;overflow:hidden;}
.eac-group-title{background:#f7fafc;border-bottom:1px solid #e2e8f0;padding:10px 18px;font-size:12px;font-weight:600;letter-spacing:.04em;text-transform:uppercase;color:#4a5568;}
.eac-row{display:grid;grid-template-columns:minmax(220px,1fr) 90px 250px 180px 130px;align-items:start;gap:16px;padding:14px 18px;border-bottom:1px solid #edf2f7;transition:background-color .15s;}
.eac-row:last-child{border-bottom:none;}
.eac-row.dirty{background:#fffaf0;}
.eac-row-label{font-weight:600;color:#1a202c;}
.eac-row-hint{color:#718096;font-size:12px;margin-top:2px;}
.eac-row-current{color:#4a5568;font-size:11.5px;margin-top:4px;}
.eac-dept-tag{display:inline-flex;align-items:center;gap:8px;margin-top:4px;font-size:11px;color:#718096;}
.eac-dept-tag.own{color:#2b6cb0;font-weight:600;}
.eac-owner{display:inline-block;border-radius:12px;padding:3px 10px;font-size:11.5px;font-weight:600;}
.eac-owner-lsp{background:#e6f4ea;color:#1e7b34;}
.eac-owner-dealer{background:#fdf3e1;color:#b7791f;}
.eac-owner-al{background:#fde8e8;color:#b91c1c;}
.eac-owner-system{background:#edf2f7;color:#4a5568;}
.eac-input-group{display:flex;align-items:stretch;}
.eac-input{width:90px;border:1px solid #cbd5e0;border-right:none;border-radius:6px 0 0 6px;padding:6px 10px;font-size:13px;color:#1a202c;}
.eac-input:focus,.eac-select:focus,.eac-input-sm:focus{outline:none;border-color:#3182ce;box-shadow:0 0 0 3px rgba(49,130,206,.15);}
.eac-input.invalid,.eac-input-sm.invalid{border-color:#e53e3e;}
.eac-select{border:1px solid #cbd5e0;border-radius:0 6px 6px 0;background:#f7fafc;padding:0 8px;font-size:12.5px;color:#2d3748;cursor:pointer;}
.eac-select:disabled{cursor:default;}
.eac-range{color:#a0aec0;font-size:11px;margin-top:4px;display:flex;align-items:center;gap:8px;flex-wrap:wrap;}
.eac-range-edit{display:flex;align-items:center;gap:6px;margin-top:6px;font-size:11.5px;color:#4a5568;}
.eac-input-sm{width:62px;border:1px solid #cbd5e0;border-radius:5px;padding:3px 6px;font-size:12px;}
.eac-error{color:#e53e3e;font-size:11.5px;margin-top:3px;}
.eac-was{color:#c05621;font-size:11.5px;margin-top:3px;}
.eac-warn{display:flex;align-items:flex-start;gap:4px;color:#b7791f;font-size:11.5px;margin-top:4px;}
.eac-toggles{display:flex;flex-direction:column;gap:8px;}
.eac-toggle{display:inline-flex;align-items:center;gap:8px;cursor:pointer;font-size:12.5px;color:#2d3748;user-select:none;}
.eac-toggle input{position:absolute;opacity:0;width:0;height:0;}
.eac-switch{position:relative;width:32px;height:18px;border-radius:9px;background:#cbd5e0;transition:background-color .15s;flex-shrink:0;}
.eac-switch:after{content:'';position:absolute;top:2px;left:2px;width:14px;height:14px;border-radius:50%;background:#fff;box-shadow:0 1px 2px rgba(0,0,0,.2);transition:left .15s;}
.eac-toggle input:checked + .eac-switch{background:#2b6cb0;}
.eac-toggle input:checked + .eac-switch:after{left:16px;}
.eac-toggle input:focus + .eac-switch{box-shadow:0 0 0 3px rgba(49,130,206,.25);}
.eac-toggle input:disabled + .eac-switch{opacity:.5;}
.eac-toggle.disabled{cursor:not-allowed;}
.eac-na{color:#a0aec0;font-size:12px;font-style:italic;}
.eac-actions{display:flex;gap:6px;justify-content:flex-end;}
.eac-savebar{position:sticky;bottom:0;display:flex;align-items:center;justify-content:space-between;flex-wrap:wrap;gap:10px;background:#1a202c;color:#fff;border-radius:8px;padding:12px 18px;margin-top:8px;box-shadow:0 -4px 12px rgba(0,0,0,.12);z-index:5;}
.eac-savebar .eac-btn-outline{background:transparent;border-color:#4a5568;color:#e2e8f0;}
.eac-savebar .eac-btn-outline:hover:not(:disabled){background:#2d3748;}
.eac-notice{display:flex;gap:10px;align-items:flex-start;background:#ebf8ff;border:1px solid #bee3f8;color:#2c5282;border-radius:8px;padding:10px 14px;margin-bottom:16px;font-size:12.5px;}
.eac-cards{display:grid;grid-template-columns:repeat(auto-fit,minmax(340px,1fr));gap:16px;}
.eac-card{background:#fff;border:1px solid #e2e8f0;border-radius:8px;display:flex;flex-direction:column;overflow:hidden;}
.eac-card-head{display:flex;align-items:flex-start;justify-content:space-between;gap:10px;padding:14px 18px;border-bottom:1px solid #edf2f7;}
.eac-card-l1{border-top:4px solid #2b6cb0;}
.eac-card-l2{border-top:4px solid #dd6b20;}
.eac-level{display:inline-block;border-radius:4px;padding:2px 8px;font-size:11px;font-weight:700;letter-spacing:.04em;margin-bottom:4px;}
.eac-card-l1 .eac-level{background:#ebf8ff;color:#2b6cb0;}
.eac-card-l2 .eac-level{background:#fffaf0;color:#c05621;}
.eac-card-title{font-size:15px;font-weight:600;color:#1a202c;margin:0;}
.eac-card-desc{color:#718096;font-size:12px;margin-top:4px;}
.eac-card-body{padding:14px 18px;flex:1;}
.eac-chips{display:flex;flex-wrap:wrap;gap:8px;min-height:38px;}
.eac-chip{display:inline-flex;align-items:center;gap:6px;background:#f7fafc;border:1px solid #e2e8f0;border-radius:16px;padding:4px 6px 4px 12px;font-size:12.5px;color:#2d3748;}
.eac-chip.added{background:#f0fff4;border-color:#9ae6b4;}
.eac-chip-x{display:inline-flex;align-items:center;justify-content:center;width:20px;height:20px;border-radius:50%;border:none;background:transparent;color:#a0aec0;cursor:pointer;padding:0;}
.eac-chip-x:hover{background:#fed7d7;color:#c53030;}
.eac-empty{color:#a0aec0;font-style:italic;padding:8px 0;}
.eac-add{display:flex;gap:8px;margin-top:14px;}
.eac-add input{flex:1;border:1px solid #cbd5e0;border-radius:6px;padding:7px 10px;font-size:13px;}
.eac-add input:focus{outline:none;border-color:#3182ce;box-shadow:0 0 0 3px rgba(49,130,206,.15);}
.eac-add input.invalid{border-color:#e53e3e;}
.eac-card-foot{display:flex;align-items:center;justify-content:space-between;gap:8px;background:#f7fafc;border-top:1px solid #edf2f7;padding:10px 18px;}
.eac-muted{color:#718096;font-size:12px;}
.eac-state{background:#fff;border:1px solid #e2e8f0;border-radius:8px;padding:48px 20px;text-align:center;color:#718096;}
.eac-state h5{color:#2d3748;margin:12px 0 4px;}
.eac-spinner{width:28px;height:28px;border:3px solid #e2e8f0;border-top-color:#2b6cb0;border-radius:50%;animation:eac-spin .8s linear infinite;display:inline-block;}
@keyframes eac-spin{to{transform:rotate(360deg);}}
@media (max-width: 1100px){
  .eac-row{grid-template-columns:1fr;gap:10px;}
  .eac-toggles{flex-direction:row;gap:18px;flex-wrap:wrap;}
  .eac-actions{justify-content:flex-start;}
}
`;

// ---- pure helpers (field = { value, unit, limits, exclude_sundays, exclude_holidays, ... }) -------
const formatAmount = (n, unit) => {
    var w = UNIT_WORDS[unit] || [unit, unit];
    return n + ' ' + (Number(n) === 1 ? w[0] : w[1]);
};
const unitWord = (unit) => (UNIT_WORDS[unit] || [unit, unit])[1];
// Same rough size the server compares with (epodWorkingTime.nominalHours) - exclusions ignored.
const nominalHours = (f) => {
    var n = Number(f.value);
    return f.unit === 'hours' ? n : f.unit === 'days' ? n * 24 : n * 30 * 24;
};
const isWholePositive = (v) => {
    if (v === '' || v === null || v === undefined) return false;
    var n = Number(v);
    return isFinite(n) && Number.isInteger(n) && n >= 1;
};
const editableCopy = (f) => ({
    value: f.value, unit: f.unit,
    limits: JSON.parse(JSON.stringify(f.limits || {})),
    exclude_sundays: f.exclude_sundays === true, exclude_holidays: f.exclude_holidays === true,
});
// Value carried over when the unit changes: exact conversions only, otherwise left blank to re-enter.
const convertValue = (value, from, to) => {
    var n = Number(value);
    if (!isWholePositive(value) || from === to) return value;
    if (from === 'days' && to === 'hours') return n * 24;
    if (from === 'hours' && to === 'days') return n % 24 === 0 ? n / 24 : '';
    return '';
};

export default class EpodAdminConfigScreen extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            authorized: true,
            loadError: false,
            activeTab: 'configurations',
            fieldOrder: [],
            fields: {},
            edits: {},
            rangeOpen: {},
            holidayCount: 0,
            hardMinHours: {},
            savingKey: null,
            savingAll: false,
            savedEmails: { 1: [], 2: [] },
            draftEmails: { 1: [], 2: [] },
            newEmail: { 1: '', 2: '' },
            emailInputError: { 1: '', 2: '' },
            savingLevel: null,
            show: false, basicTitle: '', basicText: '', basicType: 'success',
            confirm: null,
        };
    }

    componentDidMount() {
        this.loadOptions();
    }

    loadOptions = () => {
        this.setState({ loading: true, loadError: false });
        redirectURL.post("/billing/epodAdminConfigOptions", withDeptCode({}), authHeaders())
            .then((resp) => {
                if (resp.data && resp.data.status === "success") {
                    var list = Array.isArray(resp.data.fields) ? resp.data.fields : [];
                    var fields = {}, edits = {};
                    list.forEach(function (f) { fields[f.key] = f; edits[f.key] = editableCopy(f); });
                    var team = resp.data.al_team || {};
                    var l1 = team.level1_emails || [], l2 = team.level2_emails || [];
                    this.setState({
                        loading: false, authorized: true,
                        fieldOrder: list.map((f) => f.key), fields: fields, edits: edits, rangeOpen: {},
                        // The dept the server is editing: SPD unless per-dept SLAs are switched on in the backend.
                        slaDept: resp.data.dept_code || 'SPD',
                        holidayCount: Number(resp.data.holiday_count) || 0,
                        hardMinHours: resp.data.hard_min_hours || {},
                        savedEmails: { 1: l1, 2: l2 }, draftEmails: { 1: l1.slice(), 2: l2.slice() },
                        newEmail: { 1: '', 2: '' }, emailInputError: { 1: '', 2: '' },
                    });
                } else {
                    this.setState({ loading: false, authorized: false });
                }
            })
            .catch((err) => {
                if (err.response && err.response.status === 403) this.setState({ loading: false, authorized: false });
                else this.setState({ loading: false, loadError: true });
            });
    }

    // ---- alerts --------------------------------------------------------------------------------
    showAlert = (type, title, text) => this.setState({ show: true, basicType: type, basicTitle: title, basicText: text || '' });
    closeAlert = () => this.setState({ show: false });
    askConfirm = (title, text, confirmLabel, onConfirm) => this.setState({ confirm: { title: title, text: text, confirmLabel: confirmLabel, onConfirm: onConfirm } });
    closeConfirm = () => this.setState({ confirm: null });

    // ---- configurations: validation ------------------------------------------------------------
    // Each mirrors a check in epodAdminConfigService.proposeField / checkDealerWindows.
    rangeError = (key) => {
        var e = this.state.edits[key];
        if (!e) return '';
        var units = Object.keys(e.limits || {});
        for (var i = 0; i < units.length; i++) {
            var l = e.limits[units[i]] || {};
            if (!isWholePositive(l.min) || !isWholePositive(l.max)) return 'Range values must be whole numbers of at least 1';
            if (Number(l.min) > Number(l.max)) return 'Minimum cannot be greater than maximum (' + unitWord(units[i]) + ')';
        }
        return '';
    }

    valueError = (key) => {
        var e = this.state.edits[key];
        var def = this.state.fields[key] || {};
        if (!e) return '';
        if (e.value === '' || e.value === null || e.value === undefined) return 'Required';
        if (!isWholePositive(e.value)) return 'Whole number of at least 1';
        var range = (e.limits || {})[e.unit];
        if (range && !this.rangeError(key) && (Number(e.value) < Number(range.min) || Number(e.value) > Number(range.max))) {
            return 'Must be ' + range.min + '-' + range.max + ' ' + unitWord(e.unit);
        }
        var hardMin = this.state.hardMinHours[key];
        if (hardMin && nominalHours(e) < hardMin) return 'Cannot be shorter than ' + hardMin + ' hours';
        if (!def.exclusions_supported && (e.exclude_sundays || e.exclude_holidays)) return 'Skipping days is not supported here';
        return this.dealerWindowError(key);
    }

    fieldError = (key) => this.valueError(key) || this.rangeError(key);

    // auto-Clean must not close an LR before the Damage/Shortage window ends - compared using the
    // values as currently edited, by rough size in hours (same as the server).
    dealerWindowError = (key) => {
        if (DEALER_WINDOW_KEYS.indexOf(key) === -1) return '';
        var ed = this.state.edits;
        if (!DEALER_WINDOW_KEYS.every((k) => ed[k] && isWholePositive(ed[k].value))) return '';
        var a = nominalHours(ed.auto_clean), d = nominalHours(ed.damage_window), sh = nominalHours(ed.shortage_window);
        var show = (k) => formatAmount(ed[k].value, ed[k].unit);
        if (a < d) {
            if (key === 'auto_clean') return 'Must be at least Confirm Damage (' + show('damage_window') + ')';
            if (key === 'damage_window') return 'Cannot be longer than Auto-mark as Clean (' + show('auto_clean') + ')';
        }
        if (a < sh) {
            if (key === 'auto_clean') return 'Must cover Confirm Shortage (' + show('shortage_window') + ')';
            if (key === 'shortage_window') return 'Cannot be longer than Auto-mark as Clean (' + show('auto_clean') + ')';
        }
        return '';
    }

    isDirty = (key) => {
        var f = this.state.fields[key], e = this.state.edits[key];
        if (!f || !e) return false;
        if (String(e.value) !== String(f.value) || e.unit !== f.unit) return true;
        if (e.exclude_sundays !== (f.exclude_sundays === true) || e.exclude_holidays !== (f.exclude_holidays === true)) return true;
        return Object.keys(e.limits || {}).some((u) => {
            var a = e.limits[u] || {}, b = (f.limits || {})[u] || {};
            return String(a.min) !== String(b.min) || String(a.max) !== String(b.max);
        });
    }

    dirtyKeys = () => this.state.fieldOrder.filter((k) => this.isDirty(k));

    // ---- configurations: editing ---------------------------------------------------------------
    patchEdit = (key, patch) => {
        this.setState((prev) => ({ edits: Object.assign({}, prev.edits, { [key]: Object.assign({}, prev.edits[key], patch) }) }));
    }

    onValueChange = (key) => (e) => this.patchEdit(key, { value: e.target.value });

    onUnitChange = (key) => (e) => {
        var unit = e.target.value;
        var cur = this.state.edits[key] || {};
        var saved = this.state.fields[key] || {};
        // Back to the saved unit restores the saved value; otherwise convert where exact.
        var value = unit === saved.unit && cur.unit !== unit ? saved.value : convertValue(cur.value, cur.unit, unit);
        this.patchEdit(key, { unit: unit, value: value });
    }

    onToggle = (key, prop) => (e) => this.patchEdit(key, { [prop]: e.target.checked });

    onLimitChange = (key, bound) => (e) => {
        var cur = this.state.edits[key] || {};
        var limits = JSON.parse(JSON.stringify(cur.limits || {}));
        limits[cur.unit] = Object.assign({}, limits[cur.unit], { [bound]: e.target.value });
        this.patchEdit(key, { limits: limits });
    }

    onToggleRange = (key) => () => {
        this.setState((prev) => ({ rangeOpen: Object.assign({}, prev.rangeOpen, { [key]: !prev.rangeOpen[key] }) }));
    }

    onResetField = (key) => () => {
        this.setState((prev) => ({
            edits: Object.assign({}, prev.edits, { [key]: editableCopy(prev.fields[key] || {}) }),
            rangeOpen: Object.assign({}, prev.rangeOpen, { [key]: false }),
        }));
    }

    // ---- configurations: saving ----------------------------------------------------------------
    payloadFor = (key) => {
        var e = this.state.edits[key] || {};
        var limits = {};
        Object.keys(e.limits || {}).forEach((u) => { limits[u] = { min: Number(e.limits[u].min), max: Number(e.limits[u].max) }; });
        return {
            key: key, value: Number(e.value), unit: e.unit, limits: limits,
            exclude_sundays: e.exclude_sundays === true, exclude_holidays: e.exclude_holidays === true,
        };
    }

    saveField = (key) => {
        return redirectURL.post("/billing/epodAdminConfigUpdateField", withDeptCode(this.payloadFor(key)), authHeaders())
            .then((resp) => {
                if (resp.data && resp.data.status === "success" && resp.data.field) {
                    var f = resp.data.field;
                    this.setState((prev) => ({
                        fields: Object.assign({}, prev.fields, { [key]: f }),
                        edits: Object.assign({}, prev.edits, { [key]: editableCopy(f) }),
                        rangeOpen: Object.assign({}, prev.rangeOpen, { [key]: false }),
                    }));
                    return { ok: true, field: f };
                }
                return { ok: false, message: (resp.data && resp.data.message) || 'Update failed.' };
            })
            .catch((err) => ({ ok: false, message: (err.response && err.response.data && err.response.data.message) || 'Update failed.' }));
    }

    // Plain-language impact of an OCR search window change, or '' when it can't be estimated.
    // A failed preview never blocks the save - the confirmation just says the estimate is missing.
    ocrPreviewText = () => {
        var p = this.payloadFor('ocr_lookback');
        return redirectURL.post("/billing/epodAdminConfigPreviewOcrLookback", withDeptCode(p), authHeaders())
            .then((resp) => {
                var d = resp.data || {};
                if (d.status !== "success") return 'The impact on waiting uploads could not be estimated.';
                var dropped = Number(d.uploads_no_longer_picked_up) || 0, added = Number(d.older_uploads_now_picked_up) || 0;
                if (dropped > 0) return dropped + ' upload' + (dropped > 1 ? 's' : '') + ' waiting for OCR will no longer be picked up and will need manual handling.';
                if (added > 0) return added + ' older upload' + (added > 1 ? 's' : '') + ' waiting for OCR will now be picked up.';
                return 'No uploads currently waiting for OCR are affected.';
            })
            .catch(() => 'The impact on waiting uploads could not be estimated.');
    }

    // Non-SPD dept being edited (server-decided; '' while per-dept SLAs are off = one shared set).
    slaDeptLabel = () => (this.state.slaDept && this.state.slaDept !== 'SPD') ? this.state.slaDept : '';

    // Dept pages only: this row goes back to following the SPD value (removes the dept's own copy).
    onUseDefault = (key) => () => {
        var label = (this.state.fields[key] || {}).label || key;
        var run = () => {
            this.closeConfirm();
            this.setState({ savingKey: key });
            redirectURL.post("/billing/epodAdminConfigResetField", withDeptCode({ key: key }), authHeaders())
                .then((resp) => {
                    if (resp.data && resp.data.status === "success" && resp.data.field) {
                        var f = resp.data.field;
                        this.setState((prev) => ({
                            savingKey: null,
                            fields: Object.assign({}, prev.fields, { [key]: f }),
                            edits: Object.assign({}, prev.edits, { [key]: editableCopy(f) }),
                            rangeOpen: Object.assign({}, prev.rangeOpen, { [key]: false }),
                        }));
                        this.showAlert('success', 'Saved', label + ' now follows SPD: ' + f.window_text + '.');
                    } else {
                        this.setState({ savingKey: null });
                        this.showAlert('danger', 'Could not save', (resp.data && resp.data.message) || 'Update failed.');
                    }
                })
                .catch((err) => {
                    this.setState({ savingKey: null });
                    this.showAlert('danger', 'Could not save', (err.response && err.response.data && err.response.data.message) || 'Update failed.');
                });
        };
        this.askConfirm('Use the SPD value?', label + ' for ' + this.slaDeptLabel() + ' will follow the SPD value again, including later SPD changes.', 'Use SPD value', run);
    }

    onSaveField = (key) => () => {
        var run = () => {
            this.closeConfirm();
            this.setState({ savingKey: key });
            this.saveField(key).then((r) => {
                this.setState({ savingKey: null });
                if (r.ok) this.showAlert('success', 'Saved', (r.field.label || key) + ' is now ' + r.field.window_text + '.');
                else this.showAlert('danger', 'Could not save', r.message);
            });
        };
        if (key !== 'ocr_lookback') return run();
        this.setState({ savingKey: key });
        this.ocrPreviewText().then((text) => {
            this.setState({ savingKey: null });
            this.askConfirm('Change the OCR search window?', text, 'Save', run);
        });
    }

    onSaveAll = () => {
        var keys = this.dirtyKeys().filter((k) => !this.fieldError(k));
        if (keys.length === 0) return;
        // The server validates each save against the OTHER values already saved, so a lengthened
        // auto-Clean must be saved before a lengthened Damage/Shortage, and a shortened one after.
        var ac = 'auto_clean';
        if (keys.indexOf(ac) !== -1) {
            var rising = nominalHours(this.state.edits[ac]) > nominalHours(this.state.fields[ac] || {});
            keys = keys.filter((k) => k !== ac);
            if (rising) keys.unshift(ac); else keys.push(ac);
        }
        var run = () => {
            this.closeConfirm();
            this.setState({ savingAll: true });
            var failures = [];
            keys.reduce((p, k) => p.then(() => this.saveField(k).then((r) => {
                if (!r.ok) failures.push(((this.state.fields[k] || {}).label || k) + ': ' + r.message);
            })), Promise.resolve()).then(() => {
                this.setState({ savingAll: false });
                if (failures.length === 0) this.showAlert('success', 'All changes saved', '');
                else this.showAlert('danger', failures.length + ' change(s) not saved', failures.join('\n'));
            });
        };
        var title = 'Save ' + keys.length + ' change' + (keys.length > 1 ? 's' : '') + '?';
        var base = 'The live workflow picks up these values within about 5 minutes.';
        if (keys.indexOf('ocr_lookback') === -1) return this.askConfirm(title, base, 'Save', run);
        this.setState({ savingAll: true });
        this.ocrPreviewText().then((text) => {
            this.setState({ savingAll: false });
            this.askConfirm(title, base + '\nOCR search window: ' + text, 'Save', run);
        });
    }

    onDiscardAll = () => {
        this.askConfirm('Discard unsaved changes?', 'Every edited setting goes back to its saved value.', 'Discard', () => {
            this.closeConfirm();
            this.setState((prev) => {
                var edits = {};
                prev.fieldOrder.forEach((k) => { edits[k] = editableCopy(prev.fields[k] || {}); });
                return { edits: edits, rangeOpen: {} };
            });
        });
    }

    onRefresh = () => {
        if (this.dirtyKeys().length > 0 || this.emailsDirty(1) || this.emailsDirty(2)) {
            this.askConfirm('Reload and lose unsaved changes?', 'Unsaved edits on both tabs will be replaced with the saved values.', 'Reload', () => {
                this.closeConfirm();
                this.loadOptions();
            });
        } else {
            this.loadOptions();
        }
    }

    // ---- AL approvals --------------------------------------------------------------------------
    emailsDirty = (level) => {
        var a = this.state.savedEmails[level] || [], b = this.state.draftEmails[level] || [];
        if (a.length !== b.length) return true;
        return a.some((x, i) => x !== b[i]);
    }

    setLevelState = (field, level, value) => {
        this.setState((prev) => ({ [field]: Object.assign({}, prev[field], { [level]: value }) }));
    }

    onNewEmailChange = (level) => (e) => {
        this.setLevelState('newEmail', level, e.target.value);
        if (this.state.emailInputError[level]) this.setLevelState('emailInputError', level, '');
    }

    onAddEmail = (level) => (e) => {
        if (e) e.preventDefault();
        var email = (this.state.newEmail[level] || '').trim();
        if (!email) return;
        var list = this.state.draftEmails[level] || [];
        if (!EMAIL_PATTERN.test(email)) return this.setLevelState('emailInputError', level, 'Enter a valid email address.');
        if (list.some((x) => x.toLowerCase() === email.toLowerCase())) return this.setLevelState('emailInputError', level, 'This email is already in the list.');
        if (list.length >= MAX_EMAILS) return this.setLevelState('emailInputError', level, 'At most ' + MAX_EMAILS + ' emails per level.');
        this.setLevelState('draftEmails', level, list.concat([email]));
        this.setLevelState('newEmail', level, '');
    }

    onRemoveEmail = (level, email) => () => {
        this.setLevelState('draftEmails', level, (this.state.draftEmails[level] || []).filter((x) => x !== email));
    }

    onDiscardEmails = (level) => () => {
        this.setLevelState('draftEmails', level, (this.state.savedEmails[level] || []).slice());
        this.setLevelState('emailInputError', level, '');
        this.setLevelState('newEmail', level, '');
    }

    onSaveEmails = (level) => () => {
        var emails = this.state.draftEmails[level] || [];
        var doSave = () => {
            this.closeConfirm();
            this.setState({ savingLevel: level });
            redirectURL.post("/billing/epodAdminConfigUpdateAlTeamEmails", { level: level, emails: emails }, authHeaders())
                .then((resp) => {
                    this.setState({ savingLevel: null });
                    if (resp.data && resp.data.status === "success") {
                        this.setLevelState('savedEmails', level, resp.data.emails);
                        this.setLevelState('draftEmails', level, resp.data.emails.slice());
                        this.showAlert('success', 'Level ' + level + ' recipients saved', '');
                    } else {
                        this.showAlert('danger', 'Could not save', (resp.data && resp.data.message) || 'Update failed.');
                    }
                })
                .catch((err) => {
                    this.setState({ savingLevel: null });
                    this.showAlert('danger', 'Could not save', (err.response && err.response.data && err.response.data.message) || 'Update failed.');
                });
        };
        if (level === 1 && emails.length === 0) {
            this.askConfirm('Remove all Level 1 recipients?', 'AL Team approval and notification mails will have no recipients until Level 1 is filled again.', 'Remove all', doSave);
        } else {
            doSave();
        }
    }

    // ---- render --------------------------------------------------------------------------------
    renderToggle(key, prop, label, busy) {
        var e = this.state.edits[key] || {};
        return (
            <label className={"eac-toggle" + (busy ? " disabled" : "")}>
                <input type="checkbox" checked={e[prop] === true} onChange={this.onToggle(key, prop)} disabled={busy} />
                <span className="eac-switch" />
                {label}
            </label>
        );
    }

    renderFieldRow(key) {
        var s = this.state;
        var def = s.fields[key] || {};
        var e = s.edits[key] || {};
        var dirty = this.isDirty(key);
        var valueError = this.valueError(key);
        var rangeError = this.rangeError(key);
        var busy = s.savingKey === key || s.savingAll;
        var units = def.allowed_units || [e.unit];
        var range = (e.limits || {})[e.unit] || {};
        var savedRange = (def.limits || {})[e.unit] || {};
        var rangeOpen = !!s.rangeOpen[key] || !!rangeError;
        return (
            <div key={key} className={"eac-row" + (dirty ? " dirty" : "")}>
                <div>
                    <div className="eac-row-label">{def.label || key}</div>
                    {def.description ? <div className="eac-row-hint">{def.description}</div> : null}
                    {def.window_text ? <div className="eac-row-current">Saved: {def.window_text}</div> : null}
                    {this.slaDeptLabel() ? (def.same_as_default
                        ? <div className="eac-dept-tag">Same as SPD</div>
                        : <div className="eac-dept-tag own">{this.slaDeptLabel()} value
                            <button type="button" className="eac-link" onClick={this.onUseDefault(key)} disabled={busy}>Use SPD value</button>
                        </div>) : null}
                </div>
                <div><span className={"eac-owner " + (OWNER_CLASS[def.owner] || 'eac-owner-system')}>{def.owner || '-'}</span></div>
                <div>
                    <div className="eac-input-group">
                        <input type="number" className={"eac-input" + (valueError ? " invalid" : "")} min={range.min} max={range.max} step="1"
                            aria-label={(def.label || key) + ' value'} value={e.value === undefined || e.value === null ? '' : e.value}
                            onChange={this.onValueChange(key)} disabled={busy} />
                        <select className="eac-select" value={e.unit} onChange={this.onUnitChange(key)} disabled={busy || units.length < 2}
                            aria-label={(def.label || key) + ' unit'}>
                            {units.map((u) => <option key={u} value={u}>{unitWord(u)}</option>)}
                        </select>
                    </div>
                    {valueError ? <div className="eac-error">{valueError}</div>
                        : dirty && (String(e.value) !== String(def.value) || e.unit !== def.unit)
                            ? <div className="eac-was">Saved value: {formatAmount(def.value, def.unit)}</div> : null}
                    <div className="eac-range">
                        <span>Allowed {range.min}-{range.max} {unitWord(e.unit)}</span>
                        <button type="button" className="eac-link" onClick={this.onToggleRange(key)} disabled={busy || !!rangeError}>
                            {rangeOpen ? 'Hide range' : 'Edit range'}
                        </button>
                    </div>
                    {rangeOpen ?
                        <div className="eac-range-edit">
                            Min <input type="number" className={"eac-input-sm" + (rangeError ? " invalid" : "")} min="1" step="1" value={range.min === undefined ? '' : range.min}
                                onChange={this.onLimitChange(key, 'min')} disabled={busy} aria-label={(def.label || key) + ' minimum'} />
                            Max <input type="number" className={"eac-input-sm" + (rangeError ? " invalid" : "")} min="1" step="1" value={range.max === undefined ? '' : range.max}
                                onChange={this.onLimitChange(key, 'max')} disabled={busy} aria-label={(def.label || key) + ' maximum'} />
                        </div> : null}
                    {rangeError ? <div className="eac-error">{rangeError}</div>
                        : rangeOpen && (String(range.min) !== String(savedRange.min) || String(range.max) !== String(savedRange.max))
                            ? <div className="eac-was">Saved range: {savedRange.min}-{savedRange.max}</div> : null}
                </div>
                <div>
                    {def.exclusions_supported ?
                        <div className="eac-toggles">
                            {this.renderToggle(key, 'exclude_sundays', 'Skip Sundays', busy)}
                            {this.renderToggle(key, 'exclude_holidays', 'Skip holidays', busy)}
                            {e.exclude_holidays && s.holidayCount === 0 ?
                                <div className="eac-warn"><Icon name="alert" size={13} />The Holiday master has no holidays yet, so no days are skipped.</div> : null}
                        </div>
                        : <span className="eac-na">Counted in full</span>}
                </div>
                <div className="eac-actions">
                    {dirty ? <button type="button" className="eac-btn eac-btn-ghost eac-btn-sm" title="Undo changes" onClick={this.onResetField(key)} disabled={busy}><Icon name="undo" size={14} /></button> : null}
                    <button type="button" className="eac-btn eac-btn-primary eac-btn-sm" onClick={this.onSaveField(key)} disabled={!dirty || !!valueError || !!rangeError || busy}>
                        <Icon name="save" size={14} />{s.savingKey === key ? 'Saving...' : 'Save'}
                    </button>
                </div>
            </div>
        );
    }

    renderConfigurationsTab() {
        var s = this.state;
        var groups = [];
        s.fieldOrder.forEach((k) => {
            var title = (s.fields[k] || {}).group || 'Other';
            var g = groups.find((x) => x.title === title);
            if (!g) groups.push(g = { title: title, keys: [] });
            g.keys.push(k);
        });
        var dirty = this.dirtyKeys();
        var invalid = dirty.filter((k) => this.fieldError(k));
        return (
            <div>
                <div className="eac-notice"><Icon name="info" /><div>Changes apply to the live e-POD workflow within about 5 minutes of saving. Skip Sundays / Skip holidays leave those days out of the count (holidays come from the Holiday master). Every change is recorded with your name and the previous value.</div></div>
                {groups.map((g) => (
                    <div className="eac-group" key={g.title}>
                        <div className="eac-group-title">{g.title}</div>
                        {g.keys.map((k) => this.renderFieldRow(k))}
                    </div>
                ))}
                {dirty.length > 0 ?
                    <div className="eac-savebar">
                        <div>
                            <strong>{dirty.length} unsaved change{dirty.length > 1 ? 's' : ''}</strong>
                            {invalid.length ? <span style={{ color: '#feb2b2', marginLeft: 10 }}>{invalid.length} need{invalid.length > 1 ? '' : 's'} fixing first</span> : null}
                        </div>
                        <div style={{ display: 'flex', gap: 8 }}>
                            <button type="button" className="eac-btn eac-btn-outline" onClick={this.onDiscardAll} disabled={s.savingAll}><Icon name="undo" size={14} />Discard</button>
                            <button type="button" className="eac-btn eac-btn-primary" onClick={this.onSaveAll} disabled={s.savingAll || invalid.length === dirty.length}>
                                <Icon name="save" size={14} />{s.savingAll ? 'Saving...' : 'Save all'}
                            </button>
                        </div>
                    </div> : null}
            </div>
        );
    }

    renderLevelCard(level) {
        var s = this.state;
        var draft = s.draftEmails[level] || [];
        var saved = s.savedEmails[level] || [];
        var dirty = this.emailsDirty(level);
        var busy = s.savingLevel === level;
        var error = s.emailInputError[level];
        return (
            <div className={"eac-card " + (level === 1 ? "eac-card-l1" : "eac-card-l2")}>
                <div className="eac-card-head">
                    <div>
                        <span className="eac-level">LEVEL {level}</span>
                        <h6 className="eac-card-title">{level === 1 ? 'AL Team - Primary' : 'AL Team - Escalation'}</h6>
                        <div className="eac-card-desc">
                            {level === 1
                                ? 'Receives every AL approval and notification mail: late e-POD uploads, OCR re-upload holds, OCR manual review, dealer Shortage/Damage, NDV rejection, Credit Note/COF, signed uploads, and the 1st escalation.'
                                : 'Receives only the 2nd escalation, when an NDV is still not actioned after Level 1. Uses the Level 1 list while this is empty.'}
                        </div>
                    </div>
                    <span className="eac-tab-count">{draft.length}</span>
                </div>
                <div className="eac-card-body">
                    <div className="eac-chips">
                        {draft.length === 0 ?
                            <div className="eac-empty">{level === 2 ? 'No recipients - Level 1 recipients are used.' : 'No recipients - AL mails will not be sent.'}</div> : null}
                        {draft.map((email) => (
                            <span key={email} className={"eac-chip" + (saved.indexOf(email) === -1 ? " added" : "")}>
                                {email}
                                <button type="button" className="eac-chip-x" title={'Remove ' + email} aria-label={'Remove ' + email}
                                    onClick={this.onRemoveEmail(level, email)} disabled={busy}><Icon name="x" size={12} /></button>
                            </span>
                        ))}
                    </div>
                    <form className="eac-add" onSubmit={this.onAddEmail(level)}>
                        <input type="email" className={error ? "invalid" : ""} placeholder="Add email address and press Enter"
                            value={s.newEmail[level]} onChange={this.onNewEmailChange(level)} disabled={busy} aria-label={'Add Level ' + level + ' email'} />
                        <button type="submit" className="eac-btn eac-btn-outline" disabled={busy || !(s.newEmail[level] || '').trim()}><Icon name="plus" size={14} />Add</button>
                    </form>
                    {error ? <div className="eac-error">{error}</div> : null}
                </div>
                <div className="eac-card-foot">
                    <span className="eac-muted">{dirty ? 'Unsaved changes' : draft.length + ' of ' + MAX_EMAILS + ' recipients'}</span>
                    <div style={{ display: 'flex', gap: 8 }}>
                        <button type="button" className="eac-btn eac-btn-outline eac-btn-sm" onClick={this.onDiscardEmails(level)} disabled={!dirty || busy}>Discard</button>
                        <button type="button" className="eac-btn eac-btn-primary eac-btn-sm" onClick={this.onSaveEmails(level)} disabled={!dirty || busy}>
                            <Icon name="save" size={14} />{busy ? 'Saving...' : 'Save'}
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    renderAlApprovalsTab() {
        return (
            <div>
                <div className="eac-notice"><Icon name="info" /><div>These lists are the only source for AL Team mails. Add or remove addresses, then press Save on that card.{pageDept() ? (' They are shared by all departments' + (this.slaDeptLabel() ? '.' : ', and so are the SLA timelines.')) : ''}</div></div>
                <div className="eac-cards">
                    {this.renderLevelCard(1)}
                    {this.renderLevelCard(2)}
                </div>
            </div>
        );
    }

    renderBody() {
        var s = this.state;
        if (s.loading) return <div className="eac-state"><span className="eac-spinner" /><h5>Loading configuration</h5></div>;
        if (!s.authorized) return <div className="eac-state"><Icon name="lock" size={32} /><h5>Access restricted</h5><div>You do not have permission to view or change this configuration.</div></div>;
        if (s.loadError) return (
            <div className="eac-state">
                <h5>Could not load configuration</h5>
                <div style={{ marginBottom: 14 }}>Check your connection and try again.</div>
                <button type="button" className="eac-btn eac-btn-primary" onClick={this.loadOptions}><Icon name="refresh" size={14} />Retry</button>
            </div>
        );
        var cfgDirty = this.dirtyKeys().length > 0;
        var alDirty = this.emailsDirty(1) || this.emailsDirty(2);
        var recipients = (s.draftEmails[1] || []).length + (s.draftEmails[2] || []).length;
        return (
            <div>
                <div className="eac-tabs" role="tablist">
                    <button type="button" role="tab" aria-selected={s.activeTab === 'configurations'}
                        className={"eac-tab" + (s.activeTab === 'configurations' ? " active" : "")} onClick={() => this.setState({ activeTab: 'configurations' })}>
                        <Icon name="sliders" />Configurations<span className="eac-tab-count">{s.fieldOrder.length}</span>{cfgDirty ? <span className="eac-dot" title="Unsaved changes" /> : null}
                    </button>
                    <button type="button" role="tab" aria-selected={s.activeTab === 'al_approvals'}
                        className={"eac-tab" + (s.activeTab === 'al_approvals' ? " active" : "")} onClick={() => this.setState({ activeTab: 'al_approvals' })}>
                        <Icon name="users" />AL Approvals<span className="eac-tab-count">{recipients}</span>{alDirty ? <span className="eac-dot" title="Unsaved changes" /> : null}
                    </button>
                </div>
                {s.activeTab === 'configurations' ? this.renderConfigurationsTab() : this.renderAlApprovalsTab()}
            </div>
        );
    }

    render() {
        var s = this.state;
        return (
            <div className="eac-page">
                <style>{STYLES}</style>
                <div className="eac-header">
                    <div>
                        <h4 className="eac-title">e-POD Admin Configuration</h4>
                        <p className="eac-subtitle">{this.slaDeptLabel()
                            ? this.slaDeptLabel() + ' SLA timelines (rows not changed for ' + this.slaDeptLabel() + ' use the SPD value) and AL Team recipients for the e-POD workflow'
                            : 'SLA timelines and AL Team recipients for the e-POD workflow'}</p>
                    </div>
                    {s.authorized && !s.loading ?
                        <button type="button" className="eac-btn eac-btn-outline" onClick={this.onRefresh} title="Reload saved values">
                            <Icon name="refresh" size={14} />Refresh
                        </button> : null}
                </div>
                {this.renderBody()}
                <SweetAlert show={s.show} type={s.basicType} title={s.basicTitle} onConfirm={this.closeAlert}>
                    {s.basicText ? <div style={{ whiteSpace: 'pre-line' }}>{s.basicText}</div> : ''}
                </SweetAlert>
                {s.confirm ?
                    <SweetAlert warning showCancel confirmBtnText={s.confirm.confirmLabel} confirmBtnBsStyle="primary"
                        title={s.confirm.title} onConfirm={s.confirm.onConfirm} onCancel={this.closeConfirm} focusCancelBtn>
                        <div style={{ whiteSpace: 'pre-line' }}>{s.confirm.text}</div>
                    </SweetAlert> : null}
            </div>
        );
    }
}
